import './ViewChangesLegend.scss';

/**
 * @description Component for displaying a legend for deployment changes (added/deleted indicators).
 *
 * @SADtrace SAD-003-6.1
 *
 * @History
 * 04-18-2025 aleksandar dukleski: DLA-1364 added function headers
 * 11-05-2025 aleksandar dukleski: DLA-1428 added history tag to function headers
 *
 * @returns {JSX.Element} Rendered component
 */
const ViewChangesLegend = () => {
  return (
    <div
      className="view-changes-legend"
      data-testid="view-changes-legend-test-id"
    >
      <span className="view-changes-legend__button view-changes-added">
        Added
      </span>
      <span className="view-changes-legend__button view-changes-deleted">
        Deleted
      </span>
    </div>
  );
};

export default ViewChangesLegend;
